/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Select_Text_For_LinkInputs */



/**
* | output |
* | --- |
* | "Select text to create a link" |
*
* @param {Editor_Select_Text_For_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_select_text_for_link = /** @type {((inputs?: Editor_Select_Text_For_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Text_For_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Text zum Verlinken auswählen")
	return /** @type {LocalizedString} */ ("Select text to create a link")
});